<template>
  <div>
    <div style="margin-bottom: 50px;">
      <div class="oilMain vux-1px-b vux-1px-t">
        <div
          class="vux-1px-b"
          v-for="(item, index) in params.intentionDetails"
          :key="index"
        >
          <x-textarea
            disabled="disabled"
            :rows="1"
            :title="item.label + ' :'"
            text-align="right"
            v-model="params.intentionDetails[index].value"
            placeholder-align="right"
            autosize
          >
          </x-textarea>
        </div>
      </div>
    </div>
    <div class="footer flex">
      <div class="buyButton" style="width: 100%" v-if="type == 'admin'">
        点击右上角进行分享
      </div>
      <div class="buyButton" style="width: 100%" v-else @click="confirm">
        确认订单
      </div>
    </div>
    <confirm
      v-model="show"
      title="提示"
      confirm-text="确定"
      @on-confirm="onConfirm"
    >
      <p style="text-align:center;">已下单成功，请点击查看</p>
    </confirm>
  </div>
</template>

<script>
import { getTempOrderDetail, clientOrderConfirm } from "@/api/order";
import { getType } from "../../utils/auth";
import { getCompanyList } from "../../api/identify";

export default {
  name: "shareOrder",
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      typeList: [
        {
          key: "1",
          value: "个人"
        },
        {
          key: "2",
          value: "公司"
        }
      ],
      params: {
        contactPhone: ""
      },

      clientId: "",
      clientType: "",
      type: "",
      show: false,
      orderId: "",
      ifDisabled: false,
      companyList: [],
      unSelect: false
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  mounted() {
    getCompanyList()
      .then(res => {
        if (res) {
          this.companyList = res.map(x => {
            return {
              key: x.id,
              value: x.companyName
            };
          });
        }
      })
      .catch(err => {
        this.$showError(err);
      });
    this.type = getType();
    this.getTempOrderDetail();
  },
  methods: {
    onConfirm() {
      this.$router.push("/intOrder/" + this.orderId);
    },
    getTempOrderDetail() {
      let that = this;
      getTempOrderDetail({ id: this.$route.params.id })
        .then(res => {
          let postData = {
            id: res.id,
            title: res.intentionDetails[1].value
          };
          try {
            window._czc.push(["_trackEvent", "操作", "分享"]);
          } catch (err) {
            console.log(err);
          }

          wx.miniProgram.postMessage({ data: JSON.stringify(postData) });

          that.params = res;
          that.clientType = res.buyerType;
          if (that.type == "user") {
            if (that.clientType == 1) {
              if (res.contactName) {
                that.params.contactName = res.contactName;
                that.params.contactPhone = res.contactPhone;
              } else if (that.userInfo) {
                const { realName, phone } = that.userInfo;
                that.params.contactName = realName;
                that.params.contactPhone = phone;
              }
              that.params.companyId = "";
            }
            if (that.clientType == 2) {
              if (res.contactName) {
                that.params.contactName = res.contactName;
                that.params.contactPhone = res.contactPhone;
              } else {
                that.unSelect = true;
                if (that.userInfo) {
                  const { realName, phone } = that.userInfo;
                  that.params.clientName = realName;
                  that.params.contactPhone = phone;
                }
              }
              that.params.companyId = res.clientCompanyId;
            }
            if (res.clientCompanyId) {
              that.ifDisabled = true;
            }
          }
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    confirm() {
      let res = confirm("是否确认订单？");
      if (res) {
        this.$vux.loading.show();
        let req = {
          clientType: this.clientType,
          companyId: "",
          contactName: this.params.contactName,
          contactPhone: this.params.contactPhone,
          id: this.$route.params.id
        };
        if (this.clientType == 2) {
          req.companyId = this.params.companyId;
        }
        if (this.clientType == 2 && !req.companyId) {
          this.$vux.loading.hide();
          this.$showMessage("请选择公司");
        } else {
          clientOrderConfirm(req)
            .then(() => {
              this.$vux.loading.hide();
              this.$router.push({ path: "/order" });
            })
            .catch(err => {
              this.$vux.loading.hide();
              if (err.code && err.code == 38600) {
                this.orderId = err.msg;
                this.show = true;
              } else {
                this.$showMessage(err);
              }
            });
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
.disabled {
  pointer-events: none;
}
.customer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  overflow: hidden;
}
.yufu {
  display: inline-block;
  float: left;
  border: none;
  color: #ff3600;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  width: 240px;
}
.heji {
  display: block;
  overflow: hidden;
  padding: 20px 30px;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.x-oilBox {
  position: relative;
  background: #fff;
  margin: 10px 0;
  overflow: hidden;
  .border {
    background: url("../../assets/border.png") repeat;
    height: 1px;
    width: 100%;
  }
}
.middle {
  padding: 20px 30px;
}
.imgBox {
  width: 140px;
  height: 140px;
  overflow: hidden;
  margin-right: 30px;
}
.imgBox img {
  width: 100%;
  height: 100%;
  display: block;
}
.title {
  font-size: 16px;
  line-height: 32px;
  margin-bottom: 10px;
  color: #111111;
}
.spec {
  font-size: 12px;
  line-height: 32px;
  color: #919191;
  margin-bottom: 34px;
}
.money {
  font-size: 16px;
  color: #ff3600;
}

.oilMain {
  background: #fff;
  font-size: 14px;
  overflow: hidden;
  margin: 20px 0;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  height: 40px;
  line-height: 40px;
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100px;
  background: #fff;
  line-height: 100px;
  border-top: 1px solid #e8e8e8;
}
.buyButton {
  width: 220px;
  height: 100px;
  background: #039df8;
  color: #fff;
  font-size: 15px;
  text-align: center;
}
.footerLine1 {
  margin-left: 30px;
  float: left;
}
</style>
